import {AxiosInstance} from "axios";

import {RoutingRequest} from "../types/routing-service/routing-request";
import {RoutingResponse} from "../types/routing-service/routing-response";
import {PreviewDto} from "../types/schedule/preview-dto";
import {PreviewSchedulePayload} from "../types/schedule/schedule-payload";
import {ongBaseApi} from "./ong-base-api";
import {OngBaseResponse} from "./ong-base-response";
import {RoutingLogMonthResponse} from "../data/response/routing-log-response";

enum EngineApiUrl {
    Routing = "/engine/routing",
    PDPTW = "/engine/routing/pickup-and-delivery",
}

class EngineApi {
    private _api: AxiosInstance;

    constructor(api: AxiosInstance) {
        this._api = api;
    }

    async routing(
        payload: RoutingRequest
    ): Promise<OngBaseResponse<RoutingResponse>> {
        return await this._api.post(EngineApiUrl.Routing, payload);
    }

    async pdptw(
        payload: PreviewSchedulePayload
    ): Promise<OngBaseResponse<PreviewDto>> {
        return await this._api.post(EngineApiUrl.PDPTW, payload);
    }

    async getRoutingLogsMonthly(): Promise<OngBaseResponse<RoutingLogMonthResponse>> {
        return await this._api.get(`/engine/log-routings/monthly`)
    }
}

export const engineApi = new EngineApi(ongBaseApi);
